import { AbstractControl, ValidationErrors } from '@angular/forms';
import { emailsBlocked } from './emails-block';

export function corporateEmailValidator(control: AbstractControl): ValidationErrors | null {
  const domain = (control.value ?? '').split('@')[1];
  if (domain && emailsBlocked.includes(domain)) {
    return { corporateEmail: true };
  }
  return null;
}
